/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_TitleInputs */

const en_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const fr_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser l'Evenement`)
};

const de_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const it_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento diviso`)
};

const ru_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделенное событие`)
};

const es_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

const zh_cn2_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分裂事件`)
};

const ja_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割イベント`)
};

const hi_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन घटना`)
};

const pt_pt2_split_title = /** @type {(inputs: Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Split_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_title = /** @type {((inputs?: Split_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_split_title(inputs)
	if (locale === "de") return de_split_title(inputs)
	if (locale === "it") return it_split_title(inputs)
	if (locale === "ru") return ru_split_title(inputs)
	if (locale === "es") return es_split_title(inputs)
	if (locale === "zh-CN") return zh_cn2_split_title(inputs)
	if (locale === "ja") return ja_split_title(inputs)
	if (locale === "hi") return hi_split_title(inputs)
	if (locale === "pt-PT") return pt_pt2_split_title(inputs)
	return en_split_title(inputs)
});